<template>
  <div class="fg-component fg-home" v-if="has_store_data">
    <!-- trending match -->
    <article class="article-item home-trend-match home-featured" v-if="trending_match && trending_match.length">
      <div class="fg-head">
        <h1 class="title">Trending Match</h1>
        <google-news />
      </div>
      <div
        class="article-wrap"
        v-for="(match, idx) in trending_match"
        :key="idx"
      >
        <div class="article-thumbnail">
          <div class="img-box">
            <match-item
              pageHeadKey="matchTipsMatchesListHeading"
              :featuredMatches="match"
              :showYoutubeThumbnail="true"
              :withThumbnail="true"
              :imgParams="articleImgParams"
              :translations="translations"
            />
          </div>
        </div>
        <div class="article-content">
          <schedule-list :match="match" :translations="translations" />
        </div>
      </div>
    </article>
    <gamezy-ad size="mob_small" ad_id="mob_small-ad-1" :autoDetect="true" />
    <!-- trending match end-->
    <div class="match-featured-content">
      <div class="row">
        <!-- featured match -->
        <div class="col-xl-4" v-if="featured_matches && featured_matches.length">
          <div class="home-match-features">
            <div class="fg-head">
              <h2 class="title">Featured Matches</h2>
            </div>
            <match-item
              v-for="(match, idx) in featured_matches"
              :key="idx"
              pageHeadKey="matchTipsMatchesListHeading"
              :featuredMatches="match"
              :showYoutubeThumbnail="true"
              :imgParams="featuredMatchesImgParams"
              :translations="translations"
              lazyImgType="square"
            />
            <div class="col-sm-12 text-center">
              <a
                href="/match-tips-predictions"
                class="view-all-btn"
              >More Predictions</a>
            </div>
          </div>
        </div>
        <gamezy-ad size="mob_large" ad_id="mob_large-ad-1" :autoDetect="true" />
        <!-- featured Teams -->
        <div class="col-xl-4" v-if="featured_teams && featured_teams.length">
          <div class="teams">
            <div class="fg-head">
              <h2 class="title">Teams</h2>
            </div>
            <div v-for="(match, idx) in featured_teams" :key="idx">
              <match-item
                pageHeadKey="lineupMatchesListHeading"
                :featuredMatches="match"
                :showDreamTeamImg="true"
                :imgParams="(match.dream_team_image_id ? teamsImgParams : featuredMatchesImgParams)"
                :translations="translations"
                lazyImgType="square"
              />
            </div>
            <div class="col-sm-12 text-center">
              <a
                href="/lineup"
                class="view-all-btn"
              >More Teams</a>
            </div>
          </div>
        </div>
        <!-- featured Contest -->
        <div class="col-xl-4" v-if="featured_contest && featured_contest.length">
          <div class="fg-home-menu-card">
            <div class="fg-head">
              <h2 class="title">Contests</h2>
            </div>
            <div class="fg-body">
              <div class="contest-list">
                <contest-item
                  v-for="(match, idx) in featured_contest"
                  :key="idx"
                  :featuredContest="match"
                  :translations="translations"
                />
              </div>
            </div>

            <div class="col-sm-12 text-center">
              <a
                href="/best-fantasy-app-grand-league-contest"
                class="view-all-btn"
              >More Contests</a>
            </div>
          </div>
        </div>
      </div>
      <gamezy-ad size="web_small" ad_id="web_small-ad-2" :autoDetect="true" />
      <!-- Team Head To Head -->
      <div class="team-head-to-head my-5 match-featured-content" v-if="team_htoh && team_htoh.length">
        <div class="fg-head">
          <h2 class="title">Team Head To Head Records</h2>
          <a class="view-all-btn" href="/team-head-to-head">More Team Records</a>
        </div>
        <div class="fg-body">
          <div class="row">
            <htoh-item
              v-for="(team, idx) in team_htoh"
              :key="idx"
              :featuredTeam="team"
              :translations="translations"
              pageUrl="team-head-to-head"
            />
          </div>
        </div>
        <div class="col-sm-12 text-center">
          <a class="view-all-btn" href="/team-head-to-head">More Team Records</a>
        </div>
      </div>
      <!-- Player Head To Head -->
      <div class="team-head-to-head mb-5 match-featured-content" v-if="player_htoh && player_htoh.length">
        <div class="fg-head">
          <h2 class="title">Player Head To Head Records</h2>
          <a class="view-all-btn" href="/team-player-stats">More Player Battles</a>
        </div>
        <div class="fg-body">
          <div class="row">
            <htoh-item
              v-for="(player, idx) in player_htoh"
              :key="idx"
              :featuredTeam="player"
              :translations="translations"
              pageUrl="team-player-stats"
            />
          </div>
        </div>
        <div class="col-sm-12 text-center">
          <a class="view-all-btn" href="/team-player-stats">More Player Battles</a>
        </div>
      </div>
      <!-- coupon banners -->
      <div class="waf-home-coupon">
        <div class="fg-head">
          <h2 class="title">Coupons</h2>
        </div>
        <div class="fg-body">
          <div class="row waf-user-profile">
            <div class="col-xl-12">
              <div class="site-list">
                <coupon-item
                  v-for="(coupon, c_idx) in coupons"
                  :key="coupon.pid"
                  :iteration="c_idx"
                  :coupon="coupon"
                  :translations="translations"
                />
              </div>
            </div>
            <div class="col-sm-12 text-center">
              <a
                :href="getLinkWithBaseUrl('/fantasy-platforms-in-india')"
                class="view-all-btn"
              >View All</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- home-about -->
    <div class="fg-home-about">
      <div class="fg-head justify-content-center">
        <h2 class="title">About Us</h2>
      </div>

      <div class="fg-body">
        <div class="description">
          <p>
            Fantasy Gully is an aggregator service for all paid fantasy gaming platforms. It aims to educate the user about all their available options and helps maximise their profits. Users can filter their search based on the parameters such as entry value, prize pool, spots in a room and platforms to be able to choose the perfect gaming rooms for them based on their confidence level.
          </p>
          <p>
            Much like aggregator or ‘comparison’ platforms that exist for the travel and hospitality sector or for products such as mutual funds and insurance policies, Fantasy Gully is targeted toward user experience and benefit and is not affiliated with any fantasy gaming platform.
          </p>
          <p>
            Fantasy Gully is the best Fantasy Prediction website and it provides Fantasy Players with Fantasy <strong><a href="https://www.fantasygully.com/team-player-stats">Player Stats</a></strong> for each match, <strong><a href="https://www.fantasygully.com/match-tips-predictions">Fantasy Predictions</a></strong> and <strong><a href="https://www.fantasygully.com/team-head-to-head">Team Records</a></strong> to help them make winning teams for Grand Leagues, Small Leagues and Head to Head Contests.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { cssImport } from "../../assets/js/common";
import { CFG_WIDGET_URL_BASE } from "../../assets/js/config";
import homeStore from "../../store/modules/home/homeStore";
import GoogleNews from "../common/googleNews";
import MatchItem from "../common/MatchItem";
import ScheduleList from "../common/ScheduleList";
import CouponItem from "../common/couponItem";
import ContestItem from "../common/contestItem";
import HtohItem from "../common/HtohItem";
import GamezyAd from "../common/GamezyAd";

export default {
  components: {
    ScheduleList,
    GoogleNews,
    MatchItem,
    CouponItem,
    ContestItem,
    HtohItem,
    GamezyAd,
  },
  data() {
    return {
      // teamsImgParams:
      //   "?lb=200,200&background=%2347ad22&crop=65px,250px,600px,600px",
      teamsImgParams:
        "?lb=200,200&background=%2347ad22&crop=80px,220px,550px,550px",
      articleImgParams: "?w=480",
      featuredMatchesImgParams: "?w=130",
    };
  },
  computed: {
    has_store_data() {
      let homeStore = !!(this.$store.state && this.$store.state.home_store);
      return !!(homeStore && this.coupons && this.coupons.length);
    },
    trending_match() {
      return this.$store.state.home_store.trendingMatches;
    },
    featured_matches() {
      return this.$store.state.home_store.featuredMatches;
    },
    featured_teams() {
      return this.$store.state.home_store.teams;
    },
    team_htoh() {
      return this.$store.state.home_store.team_h2h;
    },
    player_htoh() {
      return this.$store.state.home_store.player_h2h;
    },
    featured_contest() {
      return this.$store.state.home_store.featuredContests;
    },
    coupons() {
      return this.$store.state.home_store.coupons;
    },
    translations() {
      return this.$store.state.translations;
    },
  },
  async serverPrefetch() {
    // serverPrefetch runs only on serverside
    this.$store.registerModule("home_store", homeStore);
    return await Promise.all([
      this.$store.dispatch("home_store/fetchHomePageApi"),
      this.$store.dispatch("home_store/fetchHomePageCoupons"),
    ]);
  },
  beforeMount() {
    this.registerStore();
  },
  mounted() {
    let hasStore = this.has_store_data;
    if (!hasStore) {
      cssImport(["/static-assets/css/home.css"]);
      this.callHomeApis();
    }
  },
  methods: {
    registerStore() {
      let hasHomeStore = this.$store.hasModule("home_store");
      if (!hasHomeStore) {
        this.$store.registerModule("home_store", homeStore, {
          preserveState: this.has_store_data,
        });
      }
    },
    callHomeApis() {
      this.$store.dispatch("home_store/fetchHomePageApi");
      this.$store.dispatch("home_store/fetchHomePageCoupons");
    },
    getLinkWithBaseUrl(path) {
      return `${CFG_WIDGET_URL_BASE}${path}`;
    },
  },
  beforeDestroy() {
    // reset home data
  },
  unmounted() {
    let hasHomeStore = this.$store.hasModule("home_store");
    if (hasHomeStore) {
      this.$store.unregisterModule("home_store");
    }
  },
};
</script>

